<ng-container *ngIf="name$ | async as name">
  <div class="d-lg-block d-none">
    <fgb-banner [title]="name"></fgb-banner>
  </div>
</ng-container>

<div class="widget-mobile">
  <div class="pt-3 pt-lg-0">
    <fgb-account-nav></fgb-account-nav>
  </div>

  <div class="container mt-0 mt-lg-4">
    <div class="points-history">
      <fgb-transaction-history [transactionTypes]="[transactionTypes.loyalty]" [accountView]="true"></fgb-transaction-history>
    </div>
  </div>
</div>
